// Get All Daily Collections Constants
export const GET_ALL_DAILY_COLLECTIONS_REQUEST = 'GET_ALL_DAILY_COLLECTIONS_REQUEST'
export const GET_ALL_DAILY_COLLECTIONS_SUCCESS = 'GET_ALL_DAILY_COLLECTIONS_SUCCESS'
export const GET_ALL_DAILY_COLLECTIONS_FAIL = 'GET_ALL_DAILY_COLLECTIONS_FAIL'
export const GET_ALL_DAILY_COLLECTIONS_RESET = 'GET_ALL_DAILY_COLLECTIONS_RESET'

// Get Daily Recovery Collections Constants
export const GET_DAILY_RECOVERY_COLLECTIONS_REQUEST = 'GET_DAILY_RECOVERY_COLLECTIONS_REQUEST'
export const GET_DAILY_RECOVERY_COLLECTIONS_SUCCESS = 'GET_DAILY_RECOVERY_COLLECTIONS_SUCCESS'
export const GET_DAILY_RECOVERY_COLLECTIONS_FAIL = 'GET_DAILY_RECOVERY_COLLECTIONS_FAIL'
export const GET_DAILY_RECOVERY_COLLECTIONS_RESET = 'GET_DAILY_RECOVERY_COLLECTIONS_RESET'

// Get Daily Flow Collections Constants
export const GET_DAILY_FLOW_COLLECTIONS_REQUEST = 'GET_DAILY_FLOW_COLLECTIONS_REQUEST'
export const GET_DAILY_FLOW_COLLECTIONS_SUCCESS = 'GET_DAILY_FLOW_COLLECTIONS_SUCCESS'
export const GET_DAILY_FLOW_COLLECTIONS_FAIL = 'GET_DAILY_FLOW_COLLECTIONS_FAIL'
export const GET_DAILY_FLOW_COLLECTIONS_RESET = 'GET_DAILY_FLOW_COLLECTIONS_RESET'